import { render, staticRenderFns } from "./TaskDetail.vue?vue&type=template&id=3d2fc366&scoped=true"
import script from "./TaskDetail.vue?vue&type=script&lang=ts"
export * from "./TaskDetail.vue?vue&type=script&lang=ts"
import style0 from "./TaskDetail.vue?vue&type=style&index=0&id=3d2fc366&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2fc366",
  null
  
)

export default component.exports